import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function parseJson<T>(value: string | null | undefined, fallback: T): T {
  if (!value) return fallback;
  try {
    return JSON.parse(value) as T;
  } catch {
    return fallback;
  }
}

export function formatPercent(value: number) {
  return `${value.toFixed(1)}%`;
}

export function hostnameFromUrl(input: string) {
  try {
    const url = new URL(input.startsWith("http") ? input : `https://${input}`);
    return url.hostname.replace(/^www\./, "");
  } catch {
    return input.replace(/^https?:\/\//, "").replace(/^www\./, "").split("/")[0];
  }
}

export function normalizeUrl(input: string) {
  const trimmed = input.trim();
  if (!trimmed) return trimmed;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

export function similarityClass(score: number) {
  if (score >= 85) return "VERY_HIGH" as const;
  if (score >= 70) return "HIGH" as const;
  if (score >= 50) return "POSSIBLE" as const;
  return "LOW" as const;
}

export { LEGAL_NOTICE } from "@/lib/labels";
